import React, { useState, useEffect } from 'react';
import H1 from '../Images/Hma.jpeg';
import L1 from '../Images/logo-w.png';
import A1 from '../Images/sig.jpeg';
import axios from 'axios';

const FeedbackForm = () => {
    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [email, setEmail] = useState('');
    const [isMember, setIsMember] = useState('');
    const [likedTopics, setLikedTopics] = useState('');
    const [speakersExpectation, setSpeakersExpectation] = useState('');
    const [attendFutureConferences, setAttendFutureConferences] = useState('');
    const [likedTopic, setLikedTopic] = useState('');
    const [overallFeedback, setOverallFeedback] = useState('');
    const [isSessionActive, setIsSessionActive] = useState(false);


    useEffect(() => {
        fetchSessionStatus();
    }, []);

    const fetchSessionStatus = async () => {
        try {
            const response = await axios.get('https://rvapi.emedha.in/pages/api/feedbackform/sessionfb_timing');
            console.log("Session Response:", response.data);

            if (response.status === 200 && response.data.length > 0) {
                const session = response.data[0];
                const currentDate = new Date();
                const startDate = new Date(session.startDate);
                const endDate = new Date(session.endDate);
                if (currentDate >= startDate && currentDate <= endDate) {
                    setIsSessionActive(true);
                } else {
                    setIsSessionActive(false);
                }
            } else {
                setIsSessionActive(false);
            }
        } catch (error) {
            console.error('Error fetching session status:', error);
            setIsSessionActive(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const feedbackData = {
            name,
            mobile,
            email,
            isMember,
            likedTopics,
            speakersExpectation,
            attendFutureConferences,
            likedTopic,
            overallFeedback
        };

        try {
            const response = await axios.post('https://rvapi.emedha.in/pages/api/api/submit-feedback', feedbackData, {
                headers: {
                    'Content-Type': 'application/json',
                }
            });

            if (response.status === 200) {
                alert(response.data.message);
                setName('');
                setMobile('');
                setEmail('');
                setIsMember('');
                setLikedTopics('');
                setSpeakersExpectation('');
                setAttendFutureConferences('');
                setLikedTopic('');
                setOverallFeedback('');
            } else {
                alert('Error submitting feedback');
            }
        } catch (error) {
            console.error('Error:', error);
            if (error.response && error.response.data && error.response.data.code === "ER_DUP_ENTRY") {
                alert("Duplicate entry detected. Your feedback has already been submitted.");
            } else {
                alert('Error submitting feedback');
            }
        }
    };

    return (
        <>
            <img src={H1} alt="item" style={{ height: '150px', width: '100%' }} />
            {isSessionActive ? (
                <div>
                    <form onSubmit={handleSubmit} style={{ padding: '20px', backgroundColor: '#f4f4f9', borderRadius: '8px' }}>
                        <div className='row'>
                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Name:</label>
                                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
                            </div>

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Mobile:</label>
                                <input type="text" value={mobile} onChange={(e) => setMobile(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} maxLength={10} />
                            </div>

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Email:</label>
                                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
                            </div>

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Are you a member of HMA?</label>
                                <select
                                    value={isMember}
                                    onChange={(e) => setIsMember(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
                                    <option value="">Select</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                </select>
                            </div>

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Did you like the Topic? </label>
                                <select
                                    value={likedTopics}
                                    onChange={(e) => setLikedTopics(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
                                    <option value="">Select</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                </select>
                            </div>     

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Did the Speakers deliver up to your expectation?</label>
                                <select
                                    value={speakersExpectation}
                                    onChange={(e) => setSpeakersExpectation(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
                                    <option value="">Select</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                </select>
                            </div>

                            <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Will you be attend future Seminars/Conferences</label>
                                <select
                                    value={attendFutureConferences}
                                    onChange={(e) => setAttendFutureConferences(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}>
                                    <option value="">Select</option>
                                    <option value="Y">Yes</option>
                                    <option value="N">No</option>
                                </select>
                            </div>

                            {/* <div className='col-6' style={{ marginBottom: '10px' }}>
                                <label>Which topic did you like the most?</label>
                                <input
                                    type="text"
                                    value={likedTopic}
                                    onChange={(e) => setLikedTopic(e.target.value)}
                                    required
                                    style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }}
                                />
                            </div> */}
                        </div>
                        <div style={{ marginBottom: '10px' }}>
                            <label>Overall Feedback:</label>
                            <textarea
                                value={overallFeedback}
                                onChange={(e) => setOverallFeedback(e.target.value)}
                                required
                                style={{ width: '100%', padding: '8px', margin: '5px 0', borderRadius: '5px' }} />
                        </div>
                        <button className='btn btn-primary btn-sm w-100' type="submit" >Submit</button>
                    </form>
                    <img src={A1} alt="item" style={{ height: '1px', width: '1%' }} />
                </div>
            ) : (
                <div>
                    <p style={{ color: 'red', textAlign: 'center' }}>The feedback form is not available because the session is not currently active.</p>
                </div>
            )}
            <footer style={{ backgroundColor: '#f1f1f1', padding: '10px 0', textAlign: 'center', marginTop: '20px' }}>
                <div>
                    <p style={{ margin: '0', fontSize: '14px' }}>Powered by
                        <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#4CAF50', textDecoration: 'none', marginLeft: '5px' }}>
                            EMedha Technologies
                        </a>
                    </p>
                    <a href="https://emedha.com/" target="_blank" rel="noopener noreferrer">
                        <img src={L1} alt="EMedha Technologies Logo" style={{ width: '200px', height: 'auto', marginTop: '10px' }} />
                    </a>
                </div>
            </footer>
        </>
    );
};

export default FeedbackForm;